import "firebase/compat/firestore";
import "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import DropDown from "../../common/dropDown";
import { AppContext } from "./../../App";
import Header from "./../../common/header";
import { getData } from "./../../common/utils";
import DemographicChart from "./demographicChart";
import EquipmentTypeChart from "./equipmentTypeChart";
import EquipmentUsageChart from "./equipmentUsage";
import MuscleGroupChart from "./muscleGroupChart";
import StatBox from "./statBox";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faPlus } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import BounceLoader from "react-spinners/BounceLoader";
const months = Array.from({ length: 12 }, (_, i) =>
  new Date(0, i).toLocaleString("default", { month: "long" })
);

const years = Array.from(
  { length: 50 },
  (_, i) => new Date().getFullYear() - i
);

function Analytics(props) {
  const [stats, setStats] = useState(null);
  const [gyms, setGyms] = useState(null);
  const [gym, setGym] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { appInfo } = useContext(AppContext);
  const [month, setMonth] = useState(0);
  const [year, setYear] = useState(0);
  const [isReportingOpen, setIsReportingOpen] = useState(false);
  const [frequency, setFrequency] = useState("Monthly");
  const [recipients, setRecipients] = useState(["admin1@gmail.com"]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  useEffect(() => {
    const fetchEquipmentData = async () => {
      try {
        const versionResponse = await getData(
          `utils/fileVersions`,
          appInfo.token
        );
        const {
          exercise_json_version: ev,
          tag_json_version: tv
        } = await versionResponse;

        const cachedEVersion = localStorage.getItem(`exercise_json_version`) ?? 2;
        const cachedTVersion = localStorage.getItem(`tag_json_version`) ?? 3;

        if (cachedEVersion != null && cachedEVersion != ev) {
          const fileResponse = await getData(
            `utils/datafile?fileType=exercise_data`,
            appInfo.token
          );
          localStorage.setItem('exercise_data', JSON.stringify(fileResponse));

          localStorage.setItem(`exercise_json_version`, ev);
        }
        if (cachedTVersion != tv) {
          const fileResponse = await getData(
            `utils/datafile?fileType=tag_data`,
            appInfo.token
          );

          localStorage.setItem(`tag_json_version`, tv);
          localStorage.setItem('tag_data', JSON.stringify(fileResponse));
        }

      } catch (error) {
        console.error("Error fetching exercise data:", error);
      }
    };

    fetchEquipmentData();
  }, []);

  const override = {
    top: '15rem',
    left: '35rem'
  };
  const availableFrequencies = [
    "Weekly",
    "Monthly",
    "2 months",
    "3 months",
    "6 months",
    "Yearly",
  ];

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    const currentDate = new Date(new Date().getFullYear(), 0, 1);

    setSelectedDate(currentDate);
    setMonth(1);
    setYear(currentDate.getFullYear());
  }, []);

  const handleGymChange = (sO) => {
    setGym(gyms[sO]);
  };

  const downloadPDF = () => {
    const element = document.getElementById("pdfContent");
    const width = element.offsetWidth;
    const height = element.offsetHeight;
    const margin = 180;

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const scale = 0.7;
    const options = {
      scale: scale,
      canvas: canvas,
      logging: true,
      width: width,
      height: height * 0.003,
    };

    html2canvas(element, options).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdfWidth = width / scale + 2 * margin;
      const pdfHeight = height / scale + 2 * margin;

      const pdf = new jsPDF("p", "px", [pdfWidth, pdfHeight]);
      pdf.setFillColor(245);
      pdf.rect(0, 0, pdfWidth, pdfHeight, "F");

      const logoUrl =
        "data:image/png;base64,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"; // Replace with your logo URL
      const iWidth = 200;
      const iHeight = 200;

      pdf.addImage(logoUrl, "PNG", margin, 10, iWidth, iHeight);
      const headerTableData = [
        ["Gym Name:", gym.name],
        [
          "Month:",
          new Date(year, month - 1).toLocaleString("default", {
            month: "long",
          }),
        ],
        ["Year:", year],
      ];

      pdf.autoTable({
        startY: 0,
        startX: -380,
        margin: { left: 0 },
        body: headerTableData,
        theme: "plain",
        styles: { fontSize: 34, cellPadding: 22 },
        columnStyles: {
          0: { fontStyle: "bold", halign: "right" },
          1: { halign: "left" },
        },
      });

      const imgWidth = pdfWidth - 2 * margin;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;

      const tableHeight = pdf.autoTable.previous.finalY;

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        tableHeight + 10,
        imgWidth,
        imgHeight
      );
      pdf.save("analytics.pdf");
    });
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);

    setMonth(date.getMonth() + 1);
    setYear(date.getFullYear());
  };
  const handleSendReport = async () => {
    const element = document.getElementById("pdfContent");
    const width = element.offsetWidth;
    const height = element.offsetHeight;
    const margin = 180;

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const scale = 0.7;
    const options = {
      scale: scale,
      canvas: canvas,
      logging: true,
      width: width,
      height: height * 0.003,
    };

    html2canvas(element, options).then(async (canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdfWidth = width / scale + 2 * margin;
      const pdfHeight = height / scale + 2 * margin;

      const pdf = new jsPDF("p", "px", [pdfWidth, pdfHeight]);
      pdf.setFillColor(245);
      pdf.rect(0, 0, pdfWidth, pdfHeight, "F");

      const logoUrl =
        "data:image/png;base64,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"; // Replace with your logo URL
      const iWidth = 200;
      const iHeight = 200;

      pdf.addImage(logoUrl, "PNG", margin, 10, iWidth, iHeight);
      const headerTableData = [
        ["Gym Name:", gym.name],
        [
          "Month:",
          new Date(year, month - 1).toLocaleString("default", {
            month: "long",
          }),
        ],
        ["Year:", year],
      ];

      pdf.autoTable({
        startY: 0,
        startX: -380,
        margin: { left: 0 },
        body: headerTableData,
        theme: "plain",
        styles: { fontSize: 34, cellPadding: 22 },
        columnStyles: {
          0: { fontStyle: "bold", halign: "right" },
          1: { halign: "left" },
        },
      });

      const imgWidth = pdfWidth - 2 * margin;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;

      const tableHeight = pdf.autoTable.previous.finalY;

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        tableHeight + 10,
        imgWidth,
        imgHeight
      );
      const formData = new FormData();
      formData.append("file", pdf.output("blob"), "analytics.pdf");
      formData.append("recipients", JSON.stringify(recipients));
      try {
        await fetch("http://localhost:3000/upload", {
          method: "POST",
          body: formData,
        });

        alert("Report sent successfully!");
      } catch (error) {
        console.error("Error sending report:", error);
        alert("Failed to send report.");
      }
    });
  };

  const handleReportingToggle = () => {
    setIsReportingOpen(!isReportingOpen);
  };

  const handleFrequencyChange = (newFrequency) => {
    setFrequency(newFrequency);
  };

  const handleAddRecipient = (email) => {
    if (!isValidEmail(email)) {
      alert("Invalid email address");
      return;
    }

    setRecipients((prevRecipients) => {
      if (prevRecipients.includes(email)) {
        return prevRecipients.filter((recipient) => recipient !== email);
      } else {
        return [...prevRecipients, email];
      }
    });
  };

  useEffect(() => {
    const fetchStats = async (gym_id) => {
      try {
        const statsData = await getData(
          `gyms/${gym_id}/stats?month=${month}&year=${year}`,
          appInfo.token
        );
        setStats(statsData[0]);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching stats:", error);
        setError("Error fetching stats. Please try again later.");
      }
    };

    if (gyms != null && gyms.length > 0 && gym != null) {
      fetchStats(gym.gym_id);
    } else {
      setStats({
        current_user_count: 0,
        last_user_count: 0,
        current_workout_count: 0,
        last_workout_count: 0,
        current_total_workout_time: 0,
        last_total_workout_time: 0,
        total_user_count: 0,
      });
    }
  }, [gym, month, year]);
  const fetchGyms = async () => {
    try {
      const org_id = appInfo.org.org_id;
      const gymsData = await getData(
        `gyms?org_id=${org_id}&u_id=${appInfo.userInfo.u_id}`,
        appInfo.token
      );
      setGyms(gymsData);
      setGym(gymsData[0]);
    } catch (error) {
      console.error("Error fetching gyms:", error);
      setError("Error fetching gyms. Please try again later.");
    }
  };
  const fetchAdmins = async (orgId) => {
    try {
      const gymAdminsData = await getData(
        `gymUsers?org_id=${orgId}`,
        appInfo.token
      );
      return gymAdminsData.map((user) => user.email);
    } catch (error) {
      console.error("Error fetching gyms:", error);
    }
  };
  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };
  useEffect(() => {
    if (appInfo && appInfo.org) {
      fetchAdmins(appInfo.org.org_id).then((emails) => {
        const validEmails = emails.filter(isValidEmail);
        setRecipients(validEmails);
      });
    }
    fetchGyms();
  }, [appInfo]);

  return (
    <div className="pageLayout" id="pdfContent">
      {isLoading ? (
        <BounceLoader
          color={`#${appInfo?.org?.branding_colors[0] ?? "#FC5A02"}`}
          loading={isLoading}
          cssOverride={override}
          size={"8rem"}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        <div className="space-y-4 ms-4">
          <div className="grid grid-flow-row grid-cols-3 gap-4">
          <div class="col-start-1 col-span-1 grid grid-flow-col grid-rows-3 gap-4">

          <div className="headerRow flex items-center gap-4 row-span-2">
            <img
              src={appInfo.org.logo}
              alt="logo"
              className="client-logo flex-none w-[5.5rem] h-auto rounded-full"
            />
            <Header
              title={appInfo.org.name}
              subtitle={appInfo.org.tagline}
              userCount={stats.total_user_count}
              addressal={(appInfo?.org?.facility_type ?? "") == "university" ? "students" : "members"}
              subtitleStyle={{
                backgroundImage: `linear-gradient(90deg,  ${appInfo.org.branding_colors[0]} 50%, ${appInfo.org.branding_colors[1]} 50%)`,
                maxWidth: "25rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "20rem"
              }}
            />
            </div>
            <div className="grid grid-cols-2 row-span-1 gap-4 justify-self-start">
              <div
                className="col-start-0 col-end-1 flex w-full"
                data-html2canvas-ignore="true"
              >
                <div className="w-6/12 w-fit">
                  {" "}
                  <DropDown
                    options={gyms.map((gym) => gym.name)}
                    onSelect={handleGymChange}
                  />
                </div>
              </div>
              <div
                className="col-start-1 col-end-2 gap-4 flex w-full"
                data-html2canvas-ignore="true"
              >
                <div className="h-fit flex flex-none">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border font-bold border-gray-300 shadow-sm px-2 py-2 bg-white text-sm text-blue-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100"
                  >
                    <DatePicker
                    className="w-[7vw]"
                      onChange={handleDateChange}
                      value={selectedDate}
                      selected={selectedDate}
                      renderMonthContent={renderMonthContent}
                      showMonthYearPicker
                      dateFormat="MMMM yyyy"
                    />
                    <svg
                      className="-mr-1 ml-2 h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 12a1 1 0 01-.707-.293l-4-4a1 1 0 011.414-1.414L10 9.586l3.293-3.293a1 1 0 111.414 1.414l-4 4A1 1 0 0110 12z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>

              </div>
              <div
                className="col-start-2 justify-self-stretch flex w-full"
                data-html2canvas-ignore="true"
              >
                <div className="h-fit flex flex-grow">
                  <button
                    type="button"
                    className="w-40 inline-flex justify-between rounded-md border font-bold border-gray-300 shadow-sm px-2 py-2 bg-white text-sm text-blue-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100"
                    onClick={handleReportingToggle}
                  >
                    <span>Reporting</span>
                    <svg
                      className="-mr-1 ml-[2rem] h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 12a1 1 0 01-.707-.293l-4-4a1 1 0 011.414-1.414L10 9.586l3.293-3.293a1 1 0 111.414 1.414l-4 4A1 1 0 0110 12z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            {isReportingOpen && (
              <div data-html2canvas-ignore="true">
                <div className="mr-[2vw]">
                  <div className="absolute z-50 mt-[2.3rem] w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 right-[1vw] mr-[-10px]">
                    <div className="py-2 border-blue-200 border-2">
                      <div className="px-4 space-y-4">
                        <div className="w-full">
                          <button
                            type="button"
                            className="inline-flex w-full justify-center rounded-md border font-bold border-gray-300 shadow-sm px-4 py-2 bg-white text-sm text-blue-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100"
                            onClick={downloadPDF}
                            style={{
                              background:
                                "linear-gradient(to left , #bdc3c7, #2c3e50)",
                              color: "white",
                            }}
                          >
                            Download Report
                            <FontAwesomeIcon icon={faDownload} className="ml-2" />
                          </button>
                        </div>
                        <label className="block text-md font-bold  text-gray-700">
                          Frequency
                        </label>
                        <div className="text-sm">
                          Receive email reports at set time interval.choose the
                          frequency
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                          {availableFrequencies.map((freq) => (
                            <button
                              key={freq}
                              type="button"
                              className={`inline-flex justify-center w-full rounded-md border px-4 py-2 text-sm ${frequency === freq
                                ? "bg-blue-600 text-white"
                                : "bg-gray-200 text-gray-700"
                                } focus:outline-none`}
                              onClick={() => handleFrequencyChange(freq)}
                            >
                              {freq}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="px-4 py-2">
                        <label className="block text-md font-bold  text-gray-700">
                          Recipients
                        </label>
                        <div className="max-h-52 overflow-y-auto overflow-x-hidden border border-gray-300 p-2 rounded-md">
                          <ul className="list-none p-0 m-0">
                            {recipients.map((recipient, index) => (
                              <li
                                key={index}
                                className="text-sm text-gray-700 flex items-center"
                              >
                                <input
                                  type="checkbox"
                                  className="mr-2"
                                  checked
                                  readOnly
                                />
                                {recipient}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <button
                          type="button"
                          className="mt-2 w-full text-md justify-center py-2 inline-flex rounded-md border border-transparent shadow-sm  bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                          onClick={() =>
                            handleAddRecipient(prompt("Enter email:"))
                          }
                        >
                          Add more recipients
                          <FontAwesomeIcon icon={faPlus} className="ml-2 mt-1" />
                        </button>
                        <button
                          type="button"
                          className="mt-2 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          onClick={handleSendReport}
                        >
                          Send Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
          
          </div>
          <div className="col-start-2 col-span-2 flex gap-x-[12rem] mt-4 justify-center">
              <StatBox
                className="flex-auto w-20"
                count={stats.current_user_count}
                unit=""
                subtext="Added members"
                progressCount={stats.last_user_count}
                progress=" added last month"
              />
              <StatBox
                className="flex-auto w-20"

                count={stats.current_workout_count}
                unit=""
                subtext="Workouts tracked"
                progressCount={stats.last_workout_count}
                progress=" workouts last month"
              />
              <StatBox
                className="flex-auto w-20"

                count={parseInt(stats.current_total_workout_time / 60)}
                unit="hrs"
                subtext="Time spent in gym"
                progressCount={parseInt(stats.last_total_workout_time / 60)}
                progress="hrs last month"
              />
            </div>
            </div>




          <div className="grid grid-cols-12 gap-4 mt-2">
            <div className="col-span-4 bg-white chartCard justify-between rounded-lg shadow-md p-4">
              <DemographicChart
                gym_id={gym != null ? gym.gym_id : 0}
                month={month}
                year={year}
              />
            </div>
            <div className=" col-span-4 bg-white chartCard rounded-lg shadow-md p-4" >
              <EquipmentTypeChart
                gym_id={gym != null ? gym.gym_id : 0}
                month={month}
                year={year}
              />
            </div>
            <div className=" col-span-4 bg-white  chartCard rounded-lg shadow-md p-4">
              <MuscleGroupChart
                gym_id={gym != null ? gym.gym_id : 0}
                month={month}
                year={year}
              />
            </div>
          </div>
          <div className=" col-span-10 mt-2 bg-white equipmentUsageCard rounded-lg shadow-md p-4">
            <EquipmentUsageChart
              gym_id={gym != null ? gym.gym_id : 0}
              month={month}
              year={year}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Analytics;
